import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var nullList = function nullList() {
  return [];
};

var getName = function getName(_ref) {
  var name = _ref.name;
  return name;
};

var getCategoryCodes = function getCategoryCodes(vendor) {
  var _context;

  return _objectSpread({}, vendor, {
    categoryNames: _mapInstanceProperty(_context = vendor.categories || []).call(_context, getName)
  });
};

var reshapeVendorsToSuggestions = function reshapeVendorsToSuggestions(_ref2) {
  var profiles = _ref2.profiles;
  return _mapInstanceProperty(profiles).call(profiles, getCategoryCodes);
};

export default (function (_ref3) {
  var _ref3$query = _ref3.query,
      query = _ref3$query === void 0 ? '' : _ref3$query,
      storefrontClient = _ref3.storefrontClient,
      storefrontSearchParams = _ref3.storefrontSearchParams;
  return storefrontClient.search(_objectSpread({
    limit: 20
  }, storefrontSearchParams, {
    typeAhead: query
  })).then(reshapeVendorsToSuggestions)["catch"](nullList);
});